export const userAuthTicketChecking = 'userAuthTicketChecking';
export const userAuthTicketChecked = 'userAuthTicketChecked';
export const userAuthTicketNotChecked = 'userAuthTicketNotChecked';
export const userAuthTicketError = 'userAuthTicketError';
